<div
    class="clr-wrapper avi-dropdown-button-list"
    role="list"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <avi-dropdown-button-item
        *ngFor="let action of actions; trackBy: trackByAction"
        [label]="action.label"
        [attr.disabled]="disableAction(action)"
        [shouldSkip]="disableAction(action) || hideAction(action)"
        [hidden]="hideAction(action)"
        (click)="clickAction(action)"
        class="avi-dropdown-button-list__item sel-avi-dropdown-button__item avi-dropdown-button__item"
        [ngClass]="actionClassName"
        role="listitem"
    ></avi-dropdown-button-item>
</div>
